export const PageNotAvailable = ({ text }: { text: React.ReactNode }) => {
  return <div>{text}</div>;
};
